export default "__VITE_ASSET__pbv5j7MI__"